import { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const save = async () => {
    if (f.new_password.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (f.new_password !== f.confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setOpen(false);
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e) { toast.error(apiErr(e.response?.data?.detail) || e.message); }
    setBusy(false);
  };

  return (
    <>
      <button data-testid="change-password-open"
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#2495D3] transition-colors mb-2">
        <KeyRound size={15} /> Change password
      </button>

      <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setF({ current_password: "", new_password: "", confirm: "" }); }}>
        <DialogContent className="rounded-xl max-w-sm" data-testid="change-password-dialog">
          <DialogHeader>
            <DialogTitle className="font-head flex items-center gap-2"><KeyRound size={17} /> Change password</DialogTitle>
            <DialogDescription className="text-xs text-slate-400">Enter your current password and the new one.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <div>
              <label className="text-[11px] font-mono uppercase text-slate-400">Current password</label>
              <Input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })}
                className="rounded-lg mt-1" data-testid="cp-current" autoComplete="current-password" />
            </div>
            <div>
              <label className="text-[11px] font-mono uppercase text-slate-400">New password</label>
              <Input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })}
                className="rounded-lg mt-1" data-testid="cp-new" autoComplete="new-password" />
            </div>
            <div>
              <label className="text-[11px] font-mono uppercase text-slate-400">Confirm new password</label>
              <Input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })}
                className="rounded-lg mt-1" data-testid="cp-confirm" autoComplete="new-password" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-lg" onClick={() => setOpen(false)}>Cancel</Button>
            <Button className="bg-[#2495D3] hover:bg-[#1E7AA9] rounded-lg" onClick={save} disabled={busy} data-testid="cp-save">
              {busy ? "Saving…" : "Save"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
